import * as actionTypes from "../ActionTypes";

const initialState = {
	page: 1,
	notifications: [],
	unread_notification: 0,
	loading: false,
	has_more: true,
};

export const notificationReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.NOTIFICATIONS: {
			return {
				...state,
				notifications:
					state.page > 1
						? [...state.notifications, ...action.payload]
						: action.payload,
			};
		}
		case actionTypes.UNREAD_NOTIFICATIONS: {
			return {
				...state,
				unread_notification: action.payload,
			};
		}
		case actionTypes.CHANGE_NOTIFICATIONS_PAGE: {
			return {
				...state,
				page: action.payload,
			};
		}
		case actionTypes.RESET_NOTIFICATIONS_PAGE: {
			return {
				...state,
				page: 1,
			};
		}
		case actionTypes.NOTIFICATIONS_LOADING_ENABLE: {
			return {
				...state,
				loading: true,
			};
		}
		case actionTypes.NOTIFICATIONS_LOADING_DISABLE: {
			return {
				...state,
				loading: false,
			};
		}
		case actionTypes.NOTIFICATIONS_HAS_MORE: {
			return {
				...state,
				has_more: action.payload,
			};
		}
		default: {
			return {
				...state,
			};
		}
	}
};
